/* eslint-disable */

import * as Apollo from '@apollo/client';
import { DocumentNode } from 'graphql';
import * as Types from '@99designs/graph-utils/types';

export type ProductOptionsPricingQueryVariables = Types.Exact<{
    input: Types.SelectionPricingInput;
}>;

export type ProductOptionsPricingQuery = {
    __typename: 'Query';
    selectionsPricing: {
        __typename: 'SelectionPricingResponse';
        currency: string;
        listPrice: { __typename: 'PriceDetail'; taxed: number; untaxed: number };
        pivotPrices: Types.Maybe<
            Array<{
                __typename: 'PivotPrice';
                key: string;
                value: string;
                isCompatible: boolean;
                price: { __typename: 'PriceDetail'; taxed: number; untaxed: number };
                differentialPrice: { __typename: 'PriceDetail'; taxed: number; untaxed: number };
            }>
        >;
    };
};

export const ProductOptionsPricingDocument: DocumentNode = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: { kind: 'Name', value: 'ProductOptionsPricing' },
            variableDefinitions: [
                {
                    kind: 'VariableDefinition',
                    variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                    type: {
                        kind: 'NonNullType',
                        type: {
                            kind: 'NamedType',
                            name: { kind: 'Name', value: 'SelectionPricingInput' },
                        },
                    },
                },
            ],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'selectionsPricing' },
                        arguments: [
                            {
                                kind: 'Argument',
                                name: { kind: 'Name', value: 'input' },
                                value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
                            },
                        ],
                        selectionSet: {
                            kind: 'SelectionSet',
                            selections: [
                                { kind: 'Field', name: { kind: 'Name', value: 'currency' } },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'listPrice' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'taxed' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'untaxed' },
                                            },
                                        ],
                                    },
                                },
                                {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'pivotPrices' },
                                    selectionSet: {
                                        kind: 'SelectionSet',
                                        selections: [
                                            { kind: 'Field', name: { kind: 'Name', value: 'key' } },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'value' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'isCompatible' },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'price' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'taxed' },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'untaxed',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                            {
                                                kind: 'Field',
                                                name: { kind: 'Name', value: 'differentialPrice' },
                                                selectionSet: {
                                                    kind: 'SelectionSet',
                                                    selections: [
                                                        {
                                                            kind: 'Field',
                                                            name: { kind: 'Name', value: 'taxed' },
                                                        },
                                                        {
                                                            kind: 'Field',
                                                            name: {
                                                                kind: 'Name',
                                                                value: 'untaxed',
                                                            },
                                                        },
                                                    ],
                                                },
                                            },
                                        ],
                                    },
                                },
                            ],
                        },
                    },
                ],
            },
        },
    ],
};

/**
 * __useProductOptionsPricingQuery__
 *
 * To run a query within a React component, call `useProductOptionsPricingQuery` and pass it any options that fit your needs.
 * When your component renders, `useProductOptionsPricingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProductOptionsPricingQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useProductOptionsPricingQuery(
    baseOptions: Apollo.QueryHookOptions<
        ProductOptionsPricingQuery,
        ProductOptionsPricingQueryVariables
    >
) {
    return Apollo.useQuery<ProductOptionsPricingQuery, ProductOptionsPricingQueryVariables>(
        ProductOptionsPricingDocument,
        baseOptions
    );
}
export function useProductOptionsPricingLazyQuery(
    baseOptions?: Apollo.LazyQueryHookOptions<
        ProductOptionsPricingQuery,
        ProductOptionsPricingQueryVariables
    >
) {
    return Apollo.useLazyQuery<ProductOptionsPricingQuery, ProductOptionsPricingQueryVariables>(
        ProductOptionsPricingDocument,
        baseOptions
    );
}
export type ProductOptionsPricingQueryHookResult = ReturnType<typeof useProductOptionsPricingQuery>;
export type ProductOptionsPricingLazyQueryHookResult = ReturnType<
    typeof useProductOptionsPricingLazyQuery
>;
export type ProductOptionsPricingQueryResult = Apollo.QueryResult<
    ProductOptionsPricingQuery,
    ProductOptionsPricingQueryVariables
>;
